import { Modal } from 'components/Modal';
import { ConfirmationToken } from 'components/ConfirmationToken';
import { TextM } from 'components/Text';

interface IApprovalLimitConfirmationProps {
	isOpen: boolean;
	isLoading: boolean;
	onClose: () => void;
	onConfirm: (mfaToken: string) => void;
}

const ApprovalLimitConfirmation = ({
	isOpen,
	isLoading,
	onClose,
	onConfirm,
}: IApprovalLimitConfirmationProps) => {
	return (
		<Modal title="Confirmar alteração" isOpen={isOpen} onClose={onClose}>
			<ConfirmationToken
				isLoading={isLoading}
				onClose={onClose}
				onConfirm={onConfirm}
			>
				<TextM>
					Para sua segurança, realize a autenticação do seu
					dispositivo para salvar a alteração do limite de aprovação.
				</TextM>
			</ConfirmationToken>
		</Modal>
	);
};

export default ApprovalLimitConfirmation;
